import React, { useState, useEffect, useCallback } from "react";
import axios from "axios";
import Header from '../components/Header'
import Footer from '../components/Footer'
import MainSlider from '../components/Slider/MainSlider'
import ClientSlider from '../components/Slider/ClientSlider'
import Feature from '../components/Feature'
import AboutSection from '../components/AboutSection'
import ServiceSection from '../components/ServiceSection'
import WhyusSection from '../components/WhyusSection'
import PortfolioSection from '../components/PortfolioSection'
import MobileNav from '../components/MobileNav'
import TestimonialSlider from '../components/Slider/TestimonialSlider'
import Preloader from '../components/Preloader'
import usePageSEO from '../hooks/usePageSEO'


const Home = () => {
  const [loading, setLoading] = useState(true)
  const [metaTitle, setMetaTitle] = useState('')
  const [metaDescription, setMetaDescription] = useState('')
  
  const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
  const apiUrl = apiBaseUrl+`seo?page=home`;
  
  const fetchPagedata = useCallback(async () => {
    const res = await axios.get(apiUrl);
    console.log(res.data);
    setMetaTitle(res.data?.meta_title);
    setMetaDescription(res.data?.meta_description);
  },[]);  

  useEffect(() => {
    const timer = setTimeout(() => {
      fetchPagedata();
      setLoading(false);
    }, 1000); // 1 seconds
    return () => clearTimeout(timer);
  }, [fetchPagedata]);

  usePageSEO({
    title: `${metaTitle}`,
    description: `${metaDescription}`
  }) 

  return (
        <>
          <div class="page-wrapper">
              <Header />
              { loading && ( <Preloader /> )}
              <MainSlider />
              <ClientSlider />
              <Feature />
              <AboutSection />
              <ServiceSection />
              <WhyusSection />
              <PortfolioSection />
              <TestimonialSlider />
              <Footer />
          </div>
          <MobileNav /> 
        </>
  );

}

export default Home